import React, { useState, useEffect, useContext } from 'react';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import '../../css/general.css'
import '../../css/inventory.css';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { dayJsFormatDate} from '../../commonFunctions';
import { OperationType, EventActionType, PropertyType } from '../../Constants/StorageConstants';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Select from 'react-select';
import { ICONS } from '../../img/icons'
import Icon from '../../img/Icon'
import { OperationCardToggle } from '../../commonElements.js'
import { OverlayTrigger, Tooltip, Badge, Button } from 'react-bootstrap'
import { customStyles, formatGroupLabel } from '../../common';

const EventSection = (props) => {
    const { t } = useTranslation();
    const [selectedEvent, setSelectedEvent]               = useState(null);
    const [eventOptions, setEventOptions]                 = useState([]);
    const [calendarShow, setCalendarShow]                 = useState(false);
    const [explanation, setExplanation]                   = useState("");
    const [date, setDate]                                 = useState(new Date());
    const [silos, setSilos]                               = useState([]);
    const [products, setProducts]                         = useState({label: '', options: []});
    const [selectedSilo, setSelectedSilo]                 = useState(null);
    const [selectedProduct, setSelectedProduct]           = useState(null);
    const [siloTransfer, setSiloTrasnfer]                 = useState(false);
    const [siloTransferSelected, setSiloTransferSelected] = useState(false);
    const [activeKey, setActiveKey]                       = useState(null);

    const default_product_text = { label: (t('SelectYieldProduct')), value: null };
    const default_silo_text = { label: (t('SelectStoragePlace')), value: null };

    useEffect(() => {
    }, []);

    /*  Initialize section values from context on component load or when operationType changes */
    useEffect(() => {
        if (props.purchaseListObject.purchaseObject.operationType === OperationType.Fertilizers
            || props.purchaseListObject.purchaseObject.operationType === OperationType.Pesticides) {
            const eventOptions = [
                { label: t('PurchaseList_Purchase'), value: EventActionType.Purchase },
                { label: t('PurchaseList_StartingAmount'), value: EventActionType.StartAmount },
            ];
            setEventOptions(eventOptions);
            setSelectedEvent(null);
        }
        else {
            const eventOptions = [
                { label: t('PurchaseList_OwnProduction'), value: EventActionType.OwnProduction },
                { label: t('PurchaseList_Purchase'), value: EventActionType.Purchase },
                { label: t('PurchaseList_StartingAmount'), value: EventActionType.StartAmount },
            ];
            setEventOptions(eventOptions);
            setSelectedEvent(null);
            formatValuesForProductAutocomplete();
            initializeAutocompleteValuesForSilos();
        }
        checkSiloTransfer(null);
        validateSection();
    }, [props.purchaseListObject.purchaseObject.operationType]);

    useEffect(() => {
        var list = initializeAutocompleteValuesForSilos();
        setSelectedHarvestSilo(list);
        //setSilos(getAutocompleteSilosData(selectedProduct));
    }, [selectedProduct])

    // * Validate section on selectedEvent change
    useEffect(() => {
        validateSection();
    }, [selectedEvent, siloTransferSelected, selectedSilo, selectedProduct, date, explanation]);

    // * Section validation function
    const validateSection = () => {
        var valid = false;
        if (selectedEvent !== null && date && props.purchaseListObject.purchaseObject.operationType !== null) valid = true;

        // Update context values
        var updateObject = {
            type: 'UPDATE',
            purchaseObject: {
                eventType: selectedEvent,
                eventExplanation: explanation,
                purchaseDate: date,
                siloTransfer: siloTransferSelected,
                siloId: siloTransferSelected && selectedSilo ? selectedSilo.value : null,
                productId: siloTransferSelected && selectedProduct ? selectedProduct.value : null
            },
            sectionValidation: {
                eventSection: valid
            }
        };
        props.updatePurchaseObject(updateObject);
    }

    /**
     * Activates silo transfer if OwnProduction is selected
     * @param {any} value EventActionType
     */
    const checkSiloTransfer = (value) => {
        if (value === EventActionType.OwnProduction) {
            setSiloTrasnfer(true);
            setTimeout(() => {
                setSiloTransferSelected(true);
                setActiveKey("0");
            }, 150); 
        }
        else {
            setSiloTrasnfer(false);
            setSiloTransferSelected(false);
            setActiveKey(null);
        }
    }

    /**
     * Formats the values for product autocomplete
     */
    const formatValuesForProductAutocomplete = () => {
        if (!props.mgmtData || !props.mgmtData.storages) return;
        let siloProducts = props.mgmtData.storages.filter(s => s.propertyType === PropertyType.Harvest).flatMap(storage => storage.purchaseProducts.map(product => ({ ...product, storageName: storage.name, storageId: storage.storageId })));
        // order by name
        siloProducts.sort((a, b) => a.name.localeCompare(b.name));
        let list = [];

        siloProducts.forEach((harvest) => {

            if (list.some((item) => item.value === Number(harvest.productCode)) || harvest.amount === 0) return;
            let obj = {
                suggestionGroup: 'defaultTemplates',
                label: harvest.name,
                value: Number(harvest.productCode),
                storageId: harvest.storageId,
                productCode: harvest.productCode,
                amount: harvest.amount,
                unitText: harvest.unitText
            };
            list.push(obj);
        });

        setProducts({ label: '', options: list });
    }

    /**
     * Sets values for silos autocomplete
     */
    const initializeAutocompleteValuesForSilos = () => {
        let filtered = [];

        if (selectedProduct)
            filtered = products.options.filter(d => d.productCode === selectedProduct.productCode && d.amount > 0);

        const result = filtered.map((storage) => {
            return {
                suggestionGroup: 'defaultTemplates',
                label: storage.label.trim() + ', ' + storage.amount + " " + storage.unitText,
                value: storage.storageId
            };
        });
        setSilos({ label: '', options: result });
        return result;
    }

    /**
     * Handles silo selection after product is selected
     * @param {any} silosList Needs updated list of silos (cannot be read from state)
     */
    const setSelectedHarvestSilo = (silosList) => {
        let silo = null;
        if (selectedProduct !== '' && selectedProduct) {
            silo = products.options.filter(h => h.productCode === selectedProduct.productCode && h.amount > 0);
        }
        if (silo != null && silo.length === 1) { // TODO: Should there be automatic selection if there is more than one option?
            setSelectedSilo(silosList.find(s => s.value === silo[0].storageId));
        }
        else {
            setSelectedSilo(null);
        }
    }

    return (
        <>
            <Form.Group controlId="event">
                <Form.Label className="text-dark purchase-section-header">{t('PurchaseList_EventType')}</Form.Label>
                <ButtonGroup data-toggle="buttons" className={selectedEvent === null ? 'invalid-border' : ''}>
                    {eventOptions.map((radio, i) => (
                        <ToggleButton
                            key={radio.label + i}
                            id={radio.label + i}
                            disabled={props.purchaseListObject.purchaseObject.operationType === null}
                            type="radio"
                            variant="outline-success"
                            name={radio.label + i}
                            value={radio.value}
                            checked={selectedEvent === radio.value}
                            onChange={(e) => {
                                // Cast to number
                                var value = Number(e.currentTarget.value);
                                setSelectedEvent(value);
                                checkSiloTransfer(value);
                            }}
                        >
                            {radio.label}
                        </ToggleButton>
                    ))}
                </ButtonGroup>

                {siloTransfer ? 
                    <div className="silo-transfer-section">
                        <Form.Label className="text-dark purchase-section-header silo-transfer-label">{t('PurchaseList_HarvestProduct')}</Form.Label>
                        <Accordion activeKey={activeKey}>
                            <Card className="silo-transfer-card">
                                <Card.Header className={`silo-transfer-button ${siloTransferSelected ? 'active-silo-transfer' : 'inactive-silo-transfer'}`}>
                                    <OperationCardToggle drawArrow={false} classname={siloTransferSelected ? 'active-panel silo-btn' : 'inactive-panel silo-btn-inactive silo-btn'} callback={() => {
                                        setSiloTransferSelected(!siloTransferSelected);
                                        setActiveKey(siloTransferSelected ? null : "0");
                                    }} eventKey="0">
                                        <input
                                            onChange={() => { }}
                                            aria-readonly="true"
                                            className={"silo-transfer-checkbox"}
                                            type="checkbox"
                                            checked={siloTransferSelected}
                                        />
                                        <div className="silo-btn-text">
                                            {t('PurchaseList_Transfer')}
                                        </div>
                                    </OperationCardToggle>
                                    <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={
                                        <Tooltip id="overlay" className="silo-tooltip">
                                            <br />
                                            <p>{t('PurchaseList_Tooltip')}</p>
                                        </Tooltip>
                                    }>
                                        <Button variant="outline-success" className="silo-tooltip-btn">
                                            <b>?</b>
                                        </Button>
                                    </OverlayTrigger>
                                </Card.Header>
                                <Accordion.Collapse eventKey="0">
                                    <Card.Body className={"silo-transfer-content"}>
                                        <Form key={"silo-transfer-form"}>
                                            <Form.Group controlId="silo-transfer">
                                                <Form.Label className="text-dark">{t('Product')}</Form.Label>
                                                <Select
                                                    className={`text-dark seed-quality-select ${selectedProduct?.label ? 'selected-highlight' : ''}`}
                                                    value={selectedProduct?.label ? selectedProduct : default_product_text}
                                                    onChange={(data) => setSelectedProduct(data)}
                                                    options={[products]}
                                                    styles={customStyles}
                                                    maxMenuHeight={250}
                                                />

                                                <Form.Label className="text-dark">{t('Storage')}</Form.Label>
                                                <Select
                                                    className={`text-dark seed-quality-select ${selectedSilo?.label ? 'selected-highlight' : ''}`}
                                                    value={selectedSilo?.label ? selectedSilo : default_silo_text}
                                                    onChange={(data) => setSelectedSilo(data)}
                                                    options={[silos]}
                                                    formatGroupLabel={formatGroupLabel}
                                                    styles={customStyles}
                                                    maxMenuHeight={250}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </div>
                    : ''}

                <Form.Label className="text-dark purchase-section-header">{t('NoteDescription')}</Form.Label>
                <Form.Control type="text" onChange={(event) => { setExplanation(event.target.value) }}
                    value={explanation}
                    placeholder={t('NoteDescription')}
                    maxLength={2500} />
                <div className="char-counter">{explanation.length}/2500</div>

                <Form.Label className="text-dark purchase-section-header">{t('DateLong')}</Form.Label>
                <Form.Control type="text" onClick={() => setCalendarShow(true)} placeholder={t('Date')} value={dayJsFormatDate(date)} onChange={() => { }} />

            </Form.Group>
        </>
    )
}

export default EventSection;